import { useAppSelector } from "../../Store";
import { allMessagesStore } from "../../Store/Slices/socket/AllMessagesSlice";
import {
  AppRenderAudio,
  AppRenderCtaButtons,
  AppRenderFile,
  AppRenderFlowButtons,
  AppRenderImage,
  AppRenderInfo,
  AppRenderLiveButtons,
  AppRenderSlider,
  AppRenderText,
  AppRenderVideo,
} from "../appComponents/RenderComponents";
import AppChatScreenWrapper from "../appComponents/UtilsComponents/AppChatScreenWrapper";
import { MESSAGE_TYPES } from "../utils/Enum";
import AppInputHandler from "./AppInputHandler";

interface Props {
  [otherProps: string]: any;
}

const MessagesScreen: React.FC<Props> = () => {
  //redux
  const { allMessages } = useAppSelector(allMessagesStore);

  return (
    <>
      <AppChatScreenWrapper>
        {allMessages &&
          allMessages?.length > 0 &&
          allMessages?.map((singleMsg: any, index: number) => {
            //* TEXT
            if (singleMsg?.type === MESSAGE_TYPES.TEXT) {
              return (
                <AppRenderText
                  userMessage={singleMsg?.isUser ? true : false}
                  key={index.toString()}
                  time={singleMsg?.time}
                  readStatus={singleMsg?.readStatus || "delivered"}
                >
                  {singleMsg?.text || singleMsg?.value}
                </AppRenderText>
              );
            }

            //* INFO Alert
            if (singleMsg?.type === MESSAGE_TYPES.INFO) {
              return (
                <AppRenderInfo
                  key={index.toString()}
                  userMessage={singleMsg?.isUser ? true : false}
                  time={singleMsg?.time}
                  readStatus={singleMsg?.readStatus || "delivered"}
                >
                  {singleMsg?.text || singleMsg?.value}
                </AppRenderInfo>
              );
            }

            //* FLOW BUTTONS
            if (singleMsg?.type === MESSAGE_TYPES.FLOW) {
              return (
                <AppRenderFlowButtons
                  userMessage={singleMsg?.isUser ? true : false}
                  key={index.toString()}
                  item={singleMsg}
                  time={singleMsg?.time}
                  readStatus={singleMsg?.readStatus || "delivered"}
                />
              );
            }

            //* LIVE BUTTONS
            if (singleMsg?.type === MESSAGE_TYPES.LIVE_AGENT_REQUESTED) {
              return (
                <AppRenderLiveButtons
                  userMessage={singleMsg?.isUser ? true : false}
                  key={index.toString()}
                  item={singleMsg}
                  time={singleMsg?.time}
                  readStatus={singleMsg?.readStatus || "delivered"}
                />
              );
            }
            //* CTA BUTTONS
            if (
              singleMsg?.type === MESSAGE_TYPES.LINK ||
              singleMsg?.type === MESSAGE_TYPES.MOBILE ||
              singleMsg?.type === MESSAGE_TYPES.EMAIL
            ) {
              return (
                <AppRenderCtaButtons
                  userMessage={singleMsg?.isUser ? true : false}
                  item={singleMsg}
                  key={index.toString()}
                  time={singleMsg?.time}
                  readStatus={singleMsg?.readStatus || "delivered"}
                />
              );
            }

            //* VIDEO
            if (singleMsg?.type === MESSAGE_TYPES.VIDEO) {
              return (
                <AppRenderVideo
                  userMessage={singleMsg?.isUser ? true : false}
                  key={index.toString()}
                  src={singleMsg?.value?.url || ""}
                  alt={singleMsg?.value?.text || ""}
                  time={singleMsg?.time}
                  readStatus={singleMsg?.readStatus || "delivered"}
                />
              );
            }
            //* AUDIO
            if (singleMsg?.type === MESSAGE_TYPES.AUDIO) {
              return (
                <AppRenderAudio
                  userMessage={singleMsg?.isUser ? true : false}
                  key={index.toString()}
                  src={singleMsg?.value?.url || ""}
                  alt={singleMsg?.value?.text || ""}
                  time={singleMsg?.time}
                  readStatus={singleMsg?.readStatus || "delivered"}
                />
              );
            }

            //* IMAGE
            if (singleMsg?.type === MESSAGE_TYPES.IMAGE) {
              return (
                <AppRenderImage
                  userMessage={singleMsg?.isUser ? true : false}
                  key={index.toString()}
                  src={singleMsg?.value?.url || ""}
                  alt={singleMsg?.value?.text || ""}
                  time={singleMsg?.time}
                  readStatus={singleMsg?.readStatus || "delivered"}
                />
              );
            }

            //* FILE
            if (
              singleMsg?.type === MESSAGE_TYPES.FILE ||
              singleMsg?.type === MESSAGE_TYPES.DOCUMENT
            ) {
              return (
                <AppRenderFile
                  userMessage={singleMsg?.isUser ? true : false}
                  key={index.toString()}
                  src={singleMsg?.value?.url || ""}
                  name={singleMsg?.value?.fileName || "File"}
                  alt={singleMsg?.value?.text || ""}
                  time={singleMsg?.time}
                  readStatus={singleMsg?.readStatus || "delivered"}
                />
              );
            }

            //* CAROUSEL
            if (singleMsg?.type === MESSAGE_TYPES.CAROUSEL) {
              return (
                <AppRenderSlider
                  userMessage={singleMsg?.isUser ? true : false}
                  items={singleMsg?.value}
                  key={index.toString()}
                  time={singleMsg?.time}
                  readStatus={singleMsg?.readStatus || "delivered"}
                />
              );
            }

            return null;
          })}
      </AppChatScreenWrapper>
      {allMessages?.length > 0 ? <AppInputHandler /> : null}
    </>
  );
};

export default MessagesScreen;
